import { ProductSubtype } from "./../../../../models/domains/pbm/Benefit/product-subtype";
import { Injectable } from "@angular/core";

@Injectable()
export class ProductSubtypeParser {
  parse(payload: any): Array<ProductSubtype> {
    const productSubtypes: Array<ProductSubtype> = [];
    if (payload.length > 0) {
      payload.forEach((subtype) => {
        const productSubtype = new ProductSubtype();
        productSubtype.setKey(subtype.Key);
        productSubtype.setValue(subtype.Value);
        productSubtypes.push(productSubtype);
      });
    }
    return productSubtypes;
  }
}
